/** logic for pages with menu (dining, spa services, etc) */
import throttle from '../../components/modules/throttle';

const sidebar = document.querySelector('.js-menu-page-sidebar');
const wrapper = document.querySelector('.js-menu-page-wrapper');

let sidebarHeight = 0;
let wrapperHeight = 0;

if (sidebar) {
  sidebarHeight = sidebar.clientHeight;
}

if (wrapper) {
  wrapperHeight = wrapper.clientHeight;
}

window.addEventListener('scroll', throttle(() => {
  if (sidebar) {
    const offset = Math.abs((sidebar.getBoundingClientRect().top - sidebar.offsetParent.getBoundingClientRect().top)) + sidebarHeight;

    sidebar.classList.toggle('hide', ((offset - wrapperHeight) === 0));
  }
}, 100));
